// src/components/products/ProductForm/GeneralInfoSections/InclusionsExclusionsSection.jsx

import React from "react";
import { Grid } from "@mui/material";
import FormInput from "../../../inputs/FormInput";

const InclusionsExclusionsSection = ({
    formData,
    errors,
    activeLang,
    handleMultiLangChange,
}) => {
    const showArabic = activeLang === "ar";
    const showEnglish = activeLang === "en";

    return (
        <Grid container spacing={3}>
            {/* Inclusions */}
            {showArabic && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="التضمينات (عربي)"
                        type="editor"
                        name="inclusions_ar"
                        value={formData.inclusions?.ar || ''}
                        onChange={(e) =>
                            handleMultiLangChange('inclusions', 'ar', e.target.value)
                        }
                        textareaRows={150}
                        required={false}
                        error={!!errors.inclusions_ar}
                        helperText={errors.inclusions_ar}
                    />
                </Grid>
            )}

            {showEnglish && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="Inclusions (English)"
                        type="editor"
                        name="inclusions_en"
                        value={formData.inclusions?.en || ''}
                        onChange={(e) =>
                            handleMultiLangChange('inclusions', 'en', e.target.value)
                        }
                        textareaRows={150}
                        required={false}
                        error={!!errors.inclusions_en}
                        helperText={errors.inclusions_en}
                    />
                </Grid>
            )}

            {/* Exclusions */}
            {showArabic && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="الإستثناءات (عربي)"
                        type="editor"
                        name="exclusions_ar"
                        value={formData.exclusions?.ar || ''}
                        onChange={(e) =>
                            handleMultiLangChange('exclusions', 'ar', e.target.value)
                        }
                        textareaRows={150}
                        required={false}
                        error={!!errors.exclusions_ar}
                        helperText={errors.exclusions_ar}
                    />
                </Grid>
            )}

            {showEnglish && (
                <Grid item xs={12} md={6}>
                    <FormInput
                        label="Exclusions (English)"
                        type="editor"
                        name="exclusions_en"
                        value={formData.exclusions?.en || ''}
                        onChange={(e) =>
                            handleMultiLangChange('exclusions', 'en', e.target.value)
                        }
                        textareaRows={150}
                        required={false}
                        error={!!errors.exclusions_en}
                        helperText={errors.exclusions_en}
                    />
                </Grid>
            )}
        </Grid>
    );
};

export default InclusionsExclusionsSection;
